import { render } from "./master_review.vue?vue&type=template&id=7611d21d&scoped=true"
import script from "./master_review.vue?vue&type=script&lang=js"
export * from "./master_review.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7611d21d"]])

export default __exports__